import { Route, Routes } from "react-router-dom";
import MainView from "./MainView";
import CallbackView from "./CallbackView";
import { useAuth } from "./auth";
import { Button } from "@mui/material";

const ProtectedRoute = ({ children }: { children: any }) => {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <LoginView />;
  }

  return children;
};

const PageRoutes = () => {
  return (
    <Routes>
      <Route path="/callback" element={<CallbackView />} />
      <Route path="/" element={<ProtectedRoute><MainView /></ProtectedRoute>} />
    </Routes>
  )
}

const LoginView = () => {
  return <div>
    <Button>Login</Button>
  </div>
}

export default PageRoutes